import { svg } from "./dom";

// Small stroke icons (24×24, currentColor) built inline: no icon font or CDN.

function icon(...paths: (string | Record<string, string | number>)[]): SVGSVGElement {
  const el = svg("svg", {
    viewBox: "0 0 24 24",
    width: 18,
    height: 18,
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true",
    class: "icon",
  });
  for (const p of paths) {
    if (typeof p === "string") el.append(svg("path", { d: p }));
    else el.append(svg("rect", p));
  }
  return el;
}

/** Arrow leaving a tray. */
export function shareIcon(): SVGSVGElement {
  return icon("M12 3v12", "M7 8l5-5 5 5", "M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6");
}

/** Two overlapping sheets. */
export function copyIcon(): SVGSVGElement {
  return icon(
    { x: 9, y: 9, width: 12, height: 12, rx: 2 },
    "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1",
  );
}

/** Arrow leaving a door. */
export function exitIcon(): SVGSVGElement {
  return icon("M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", "M16 17l5-5-5-5", "M21 12H9");
}
